import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';

const edit = {
	DphSzbOzn: null as string | null,
	Eurotax: null as string | null,
	Hmotnost: null as number | null,
	KaroserieTyp: null as string | null,
	MotorKod: null as string | null,
	Objem: null as number | null,
	PalivoPzn: null as number | null,
	PrevodovkaKod: null as string | null,
	PrevodovkaTyp: null as string | null,
	Tablpozice: null as string | null,
	TablpoziceText: null as string | null,
	Text: null as string | null,
	Typkod: null as string | null,
	VstupDat: null as Date | null,
	Vykon: null as number | null,
	VyrobaktPrp: null as boolean | null,
	VyrobekvozOzn: null as string | null,
	ZaznamId: null as number | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		VyrobekvozOzn: [],
		Tablpozice: [],
		PalivoPzn: [],
		DphSzbOzn: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {
		[editMutations.TYP_TABULKOVA_POZICE_SELECT_MAPPER](state, { data }) {
			state.edit.Tablpozice = data.value;
			state.edit.TablpoziceText = data.text;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
